var axios = require('axios');
var { error_message } = require('@managers/helpers');

const CASES_OPEN_PATH = 'cases/open';

/**
 * Report a new case to the backend.
 *
 * @param {Object} caseData
 * @param {string} caseData.assumption - Selected assumption.
 * @param {string} caseData.comment - User comment describing the issue.
 * @param {string} caseData.distributionName - Distribution name of the field.
 * @param {string} caseData.farmingUnitName - Farming unit name of the field.
 * @param {string} caseData.fieldName - Field name.
 * @param {string} caseData.mondayId - Monday ID of the farming unit.
 * @param {string} caseData.distributionId - Distribution ID of the field (for the Monday field link).
 * @param {string} caseData.farmingUnitId - Farming unit ID of the field (for the Monday field link).
 * @param {string} caseData.fieldId - Field ID (for the Monday field link).
 * @param {string} caseData.transmitterId - Sensor identifier.
 * @param {{lat: number, lng: number}|Object|string} caseData.sensorCoordinates - Sensor coordinates.
 * @param {string} caseData.sensorSerialNumber - Sensor serial number.
 */
export const ReportCase = ({
  assumption,
  comment,
  distributionName,
  farmingUnitName,
  fieldName,
  mondayId,
  distributionId,
  farmingUnitId,
  fieldId,
  transmitter_id,
  sensorCoordinates,
  serial_number,
  sensorType,
}) => {
  const payload = {
    assumption,
    extra_comment: comment,
    distribution_name: distributionName,
    farming_unit_name: farmingUnitName,
    field_name: fieldName,
    monday_id: mondayId,
  };

  // Entity IDs let the backend build a Monday link to the field, matching the
  // link automated cases add. Sanitized below so missing IDs are omitted.
  const optionalFields = {
    distribution_id: distributionId,
    farming_unit_id: farmingUnitId,
    field_id: fieldId,
    transmitter_id: transmitter_id,
    coordinates: sensorCoordinates,
    serial_number: serial_number,
    sensor_type: sensorType,
  };

  // Remove undefined / null fields
  const sanitizedOptionalFields = Object.fromEntries(
    Object.entries(optionalFields).filter(
      ([, value]) => value !== undefined && value !== null
    )
  );

  Object.assign(payload, sanitizedOptionalFields);

  return new Promise(function (resolve, reject) {
    axios
      .post(CASES_OPEN_PATH, payload)
      .then(res => resolve(res.data))
      .catch(e => {
        console.log(error_message ? error_message(e) : e.message);
        reject(e);
      });
  });
};
